<template>
	<div class = "box">
		<div class = "search-div">
			<van-search shape="round" v-model="searchKey" placeholder="请输入搜索关键词" />
		    <div class = "location-tip">城市定位</div>
			<div v-if="sCity" class = "location-div">
				<van-icon name="location" color="this.$enums.CONSTANT.APP_THEME_COLOR"/>
				<span @click="toSearchShop()">{{sCity}}</span>
			</div>
			<div v-if="!sCity" class = "location-div" @click = "getTxlocation()">
				<van-icon name="replay" color="this.$enums.CONSTANT.APP_THEME_COLOR"/>
				<span>重新获取定位</span>
			</div>
		</div>
		<div class = "empty-div"></div>
		<div class = "city-list-div">
			<van-index-bar>
			   <div class="city-div" :class="{'city-div-bg':!searchKey}" v-for="(name_item,name_index) in this.$enum.CITY.CITYS" :key="name_index">
			     <van-index-anchor v-if="!searchKey" :index="name_item.index" />
			     <van-cell @click="selectCity(city_item.name)" v-if="!searchKey || city_item.name.indexOf(searchKey) != -1" v-for="(city_item,city_index) in name_item.citys" :title="city_item.name" :key="city_index"/>
			   </div>
			</van-index-bar>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	import { IndexBar, Cell,IndexAnchor,Search,Icon,Notify } from 'vant';
	export default {
		name : 'location',
		computed: {
			...mapGetters(["sLocation","sCity"]),
		},
		components: {
		      [IndexBar.name]: IndexBar,
		      [IndexAnchor.name]: IndexAnchor,
		      [Cell.name]: Cell,
		      [Search.name]: Search,
		      [Icon.name]: Icon,
		      [Notify.name]: Notify
		 },
		created(){
			//查询定位信息
			//this.getTxlocation();
			
		},
		beforeDestroy() {
			window.removeEventListener('message',this.messageLoc, false);
		},
		
		mounted() {
			window.addEventListener('message', this.messageLoc, false);
		},
		data(){
			return {
				searchKey:''
			}
		},
		methods:{
			messageLoc(event){
				var loc = event.data;
				// console.log(event)
				if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
				  // console.log('location', loc);
				  this.addLocation(loc.cityname,loc.latlng.lat,loc.latlng.lng);
				  this.$router.push("searchShop")
				}
			},
			...mapMutations(['sSetLocation']),
			getTxlocation(){
					var geolocation = new qq.maps.Geolocation();
					var options = {timeout: 4000};
					geolocation.getLocation(this.successPosition, this.errPosition, options)
			},
			
			successPosition(position) {
				if(position){
					this.addLocation(position.city,position.lat,position.lng);
				}
			},
			errPosition() {
				Notify({ type: 'danger', message: '定位失败' });
				// var geolocation = new qq.maps.Geolocation();
				// var options = {timeout: 6000};
				// geolocation.getIpLocation(this.successPosition, this.stopGetLocation, options)
			},
			stopGetLocation(){
				Notify({ type: 'danger', message: '定位失败' });
			},
			
			selectCity(city){
				city = city+"市";
				this.addLocation(city,'','');
				this.$router.push("searchShop")
			},
		    addLocation(city,lat,lng){
				this.sSetLocation({
					'city':city,
					'lat':lat,
					'lng':lng
				});
			},
			toSearchShop(){
				this.$router.push("searchShop")
			}
		}
		
	}
</script>

<style scoped>
	.box {
		width: 100%;
		height: 100%;
	}
	.search-div {
		position: fixed;
		top: 0px;
		left: 0px;
		padding: 15px;
		width: 100%;
		height: 128px;
		background-color: #ffffff;
		z-index: 100;
	}
	
	.search-div .van-search {
		padding: 0px;
	}
	.empty-div {
		width: 100%;
		height: 138px;
		background-color: #f5f5f5;
	}
	
	.location-div {
		display: inline-flex;
		align-items: center;
		padding-bottom: 5px;
	}
	.location-div>span {
		font-size: 17px;
		line-height: 17px;
		font-weight: 600;
		color: #363636;
		margin-left: 6px;
	}
	.location-div>i {
		font-size: 15px;
	}
	.location-tip {
		color: #858585;
		padding: 10px 0px;
		font-size: 15px;
	}
	
	.city-div-bg>div:first-child{
		background-color: #f5f5f5;
	}
	
	.city-list-div {
		height: calc(100% - 138px);
		overflow-y: auto;
	}
	
</style>
